export default "__VITE_ASSET__3bRAj378__"